import { FC } from 'react';
import './ArticleEditor.scss';
import { SimpleEditor } from '../../../@/components/tiptap-templates/simple/simple-editor';

interface ArticleEditorProps {
  className?: string;
  initialHtml?: string;
  onChange?: (value: { html: string; json: unknown }) => void;
  register: any;
  fieldName?: string;
  viewToolbar?: 'full' | 'compact' | 'none';
}

const ArticleEditor: FC<ArticleEditorProps> = ({ className, initialHtml, onChange, register, fieldName = 'content', viewToolbar }) => {
  return (
    <div className={`ArticleEditor ${className ?? ''}`} data-testid="ArticleEditor">
      <input type="hidden" {...register(fieldName)} />
      <SimpleEditor
        content={initialHtml ?? ''}
        viewToolbar={viewToolbar}
        onChange={
          (val: any) => {
            onChange?.(val ?? null);
          }
        }
      />
    </div>
  );
}

export default ArticleEditor;
